// services/AdminSpecialSetApis.js
import { api } from "./apiServices";

/**
 * Fetches special set analytics for a specific seller.
 * @param {string|number} sellerProfileId - The ID of the seller.
 * @returns {Promise<Object>} A promise that resolves to the analytics data.
 */
export const getSellerSpecialSetAnalytics = async (sellerProfileId) => {
  try {
    const response = await api.get(
      `/admin/sellers/${sellerProfileId}/special-set-analytics`
    );
    return response.data;
  } catch (error) {
    console.error(
      `Error fetching special set analytics for seller ${sellerProfileId}:`,
      error
    );
    throw error;
  }
};

/**
 * Creates a special set for a seller as an admin.
 * @param {string|number} sellerProfileId - The ID of the seller.
 * @param {Object} payload - The data for the special set.
 * @param {number} payload.number_of_leads - The number of leads for the set (used for naming/display; when total_coins is provided this is the approximate equivalent).
 * @param {number} payload.discount_percentage - The discount percentage.
 * @param {number} [payload.total_coins] - Optional. When provided, used directly as the set's coin total instead of deriving it from number_of_leads. Requires the "sales:special-set-coin-config" permission.
 * @returns {Promise<Object>} A promise that resolves to the created package data.
 */
export const adminCreateSpecialSet = async (sellerProfileId, payload) => {
  try {
    console.log("Special Set Payload:", payload);
    const response = await api.post(
      `/admin/sellers/${sellerProfileId}/create-special-set`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error(
      `Error creating special set for seller ${sellerProfileId}:`,
      error
    );
    throw error;
  }
};

/**
 * Fetches all active special set templates.
 * @returns {Promise<Array>} A promise that resolves to an array of template objects.
 */
export const getAllSpecialSetTemplates = async () => {
  try {
    // This endpoint will be created on the backend
    const response = await api.get(`/admin/sellers/special-set-templates`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching special set templates:`, error);
    throw error;
  }
};
